// The bundle's front door: one module that decides which half of klackr this
// page is, and imports only that half.
//
// ── WHAT HAS TO CHANGE IN index.html ─────────────────────────────────────────
//
//   -  <script type="module" src="/src/main.ts"></script>
//   +  <script type="module" src="/src/dashboard/entry.ts"></script>
//
// That one line is the whole integration. `main.ts` is untouched — it is
// imported from here instead of being loaded directly, so nothing about the
// game's boot changes and nothing in it needs a route guard.
//
// ── WHY NOT A SECOND VITE ENTRY (`parent.html`) ──────────────────────────────
//
// Because server/app.ts serves ONE html for every non-`/api/` path:
//
//     app.setNotFoundHandler((request, reply) => {
//       if (request.url.startsWith('/api/')) ...404 json...
//       // SPA shell for every client-side route, so /klackr/parent reloads.
//       return reply.type('text/html').send(bundle.indexHtml)
//     })
//
// and `loadClientBundle` builds `bundle.indexHtml` by reading exactly one file,
// `index.html`, and injecting `window.__KLACKR_BASE__` into it. A second entry
// would land at `dist/parent.html`, be served by the static handler at the
// literal URL `/klackr/parent.html`, and get NO base-path injection — while
// `/klackr/parent`, the URL architecture.md §2.6 actually names and §5.1's smoke
// test actually curls, would still answer with `index.html` and boot the game.
// It would work from a link and break on a hard reload, which is the one thing
// the route has to survive. Making it real means changing server/app.ts,
// server/static.ts and vite.config.ts; this branch changes one line of markup.
//
// ── WHY THE IMPORTS ARE DYNAMIC ──────────────────────────────────────────────
//
// So Rollup splits them. The game half pulls in the sprite catalogue, the atlas
// builder, the particle system and the whole scene stack; the dashboard half
// pulls in SVG string builders and a stylesheet. Neither has any business being
// downloaded by a reader of the other, and a static import of both would ship
// both to both.

import { isParentDashboardRoute } from './route.js'

if (isParentDashboardRoute(window.location.pathname)) {
  const { mountParentDashboard } = await import('./boot.js')
  mountParentDashboard()
} else {
  await import('../main.js')
}
